import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './feature/home/home.component';
import { NotfoundComponent } from './common/notfound/notfound.component';
import { LoginComponent } from './feature/login/login.component';
import { DashboardComponent } from './feature/dashboard/dashboard.component';
import { RoiComponent } from './roi/roi.component';
import { AdvancedRoiComponent } from './advanced-roi/advanced-roi.component';


const routes: Routes = [{
  path:'', component: RoiComponent
  },{
    path:'home', component: RoiComponent
  },{
    path:'advanced', component: AdvancedRoiComponent
  },{
    path: '**',
    component: NotfoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
